module.exports = __webpack_public_path__ + "static/media/behind_the_dhara.38318ec3.gif";